import { render, staticRenderFns } from "./chooseCarType.vue?vue&type=template&id=459d2883&scoped=true&"
import script from "./chooseCarType.vue?vue&type=script&lang=js&"
export * from "./chooseCarType.vue?vue&type=script&lang=js&"
import style0 from "./chooseCarType.vue?vue&type=style&index=0&id=459d2883&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d2883",
  null
  
)

component.options.__file = "chooseCarType.vue"
export default component.exports